import { ModalType, modalTypeApiPrefix } from "../types"
import { getApiClient } from "../client"
import { isValidAttendanceCode } from "../utils/isValidAttendanceCode"
import {
  UpcomingIntakeResponse,
  Intake,
  IntakeResultsResponse,
} from "../types/intake"
import {
  IntakeDate,
  IntakeDatesResponse,
  IntakeLocation,
  IntakeLocationsResponse,
} from "toptaal-shared"

export const getClosestIntakeLocations = async (page?: number) => {
  const apiClient = getApiClient()

  return await apiClient
    .get<IntakeLocationsResponse>("intakes/locations/closest", {
      searchParams: {
        page,
      },
    })
    .json()
}

export const getLocationIntakeDates = async (
  locationId: IntakeLocation["id"],
) => {
  const apiClient = getApiClient()

  return await apiClient
    .get<IntakeDatesResponse>(`intakes/locations/${locationId}`)
    .json()
}

export const scheduleStudentIntake = async (intakeId: IntakeDate["id"]) => {
  const apiClient = getApiClient()

  return await apiClient.post(`intakes/${intakeId}/students`).json()
}

export const registerStudentPresentForEvent = async ({
  entityType,
  code,
}: {
  entityType: ModalType
  code: string
}) => {
  if (!isValidAttendanceCode(code)) {
    throw new Error("De code moet uit precies 6 cijfers bestaan.")
  }

  const apiClient = getApiClient()

  return await apiClient
    .post(`${modalTypeApiPrefix[entityType]}/present`, {
      json: { code: Number(code) },
    })
    .json()
}
export const registerStudentAbsentForEvent = async ({
  entityType,
  entityId,
  absenceReason,
  reasonOther,
}: {
  entityType: ModalType
  entityId: string
  absenceReason: string
  reasonOther?: string
}) => {
  const apiClient = getApiClient()

  return await apiClient
    .post(`${modalTypeApiPrefix[entityType]}/${entityId}/absent`, {
      json: { reason: absenceReason, reasonOther },
    })
    .json()
}

export const removeStudentFromIntake = async (intakeId: Intake["id"]) => {
  const apiClient = getApiClient()

  return await apiClient.delete(`intakes/${intakeId}/students`).json()
}

export const getUpcomingIntake = async () => {
  const apiClient = getApiClient()

  return await apiClient.get<UpcomingIntakeResponse>("intakes/upcoming").json()
}

export const getStudentIntakeResults = async () => {
  const apiClient = getApiClient()

  return await apiClient.get<IntakeResultsResponse>("intakes/results").json()
}
